import { gql } from "apollo-boost"

export const updateBudgetAvailability = gql`
  mutation UpdateBudgetAvailability($data: [BudgetAvailabilityInput!]!) {
    UpdateBudgetAvailability(data: $data)
  }
`